import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelOrderImport_ds_get_vendorlots_by_materials_projects_vendorlotsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { vendorLotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], fullTextSearch?: string, materialId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } } }[] }> 
  {
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_vendorlots_by_materials_projects_vendorlots/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { vendorLotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], fullTextSearch?: string, materialId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_vendorlots_by_materials_projects_vendorlots/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { vendorLotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], fullTextSearch?: string, materialId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, Project?: { Id?: number, LookupCode?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelOrderImport/datasources/ds_get_vendorlots_by_materials_projects_vendorlots/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      vendorLotLookupcodes?: string[], materialLookupcodes?: string[], projectLookupcodes?: string[], fullTextSearch?: string, materialId?: number    }) {
      return false;
    }
}
